"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertsList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const AlertsDetail_1 = require("./AlertsDetail");
const AlertsList = (props) => {
    const { alerts, dispatch } = props;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: alerts.map((alert, index) => ((0, jsx_runtime_1.jsx)(AlertsDetail_1.AlertsDetail, { alert: alert, dispatch: dispatch }, `alerts_list_${alert.type}_${alert.id}_${index}`))) }, void 0));
};
exports.AlertsList = AlertsList;
exports.default = exports.AlertsList;
